import numeral from './numeral'
export default class Util {
  constructor() {
    this.mapCidades = this.mapCidades.bind(this)
  }
  static dateOnly(value) {
    if (value) {
      return value.substring(0, 10)
    }
    return undefined
  }
  static getLastPathComponent(url) {
    var urlChanged = url
    urlChanged = urlChanged.substr(urlChanged.lastIndexOf('/') + 1)
    return urlChanged
  }
  static getMaskedCPFCNPJ(string) {
    if (string !== null) {
      var padNumber =
        ('' + string).length <= 11
          ? string.padStart(11, 0)
          : string.padStart(14, 0)
      return ('' + string).length <= 11
        ? ('' + padNumber).substring(0, 3) +
            '.' +
            ('' + padNumber).substring(3, 6) +
            '.' +
            ('' + padNumber).substring(6, 9) +
            '-' +
            ('' + padNumber).substring(9, 11)
        : ('' + padNumber).substring(0, 2) +
            '.' +
            ('' + padNumber).substring(2, 5) +
            '.' +
            ('' + padNumber).substring(5, 8) +
            '/' +
            ('' + padNumber).substring(8, 12) +
            '-' +
            ('' + padNumber).substring(12, 14)
    }
    return ''
  }
  static getMaskedPhone(phone) {
    if (phone === null || phone === '') {
      return 'N/A'
    }
    return ('' + phone).length <= 10
      ? '(' +
          ('' + phone).substring(0, 2) +
          ') ' +
          ('' + phone).substring(2, 6) +
          '-' +
          ('' + phone).substring(6, 10)
      : '(' +
          ('' + phone).substring(0, 2) +
          ') ' +
          ('' + phone).substring(2, 7) +
          '-' +
          ('' + phone).substring(7, 11)
  }
  static remaskCurrency(value) {
    var unsmaked = value.split('.').join(',')
    return unsmaked
  }
  static unmaskCurrency(value) {
    var unsmaked = value.split('.').join('')
    unsmaked = unsmaked.split(',').join('.')
    unsmaked = unsmaked.split('R$').join('')
    return parseFloat(unsmaked)
  }
  static formatCurrency(value) {
    return numeral(value).format('$0.0,00').slice(0, -1)
  }
  static normalizeCnpjAlfanumerico(value) {
    return (Util.unmaskField(value) || '').toUpperCase()
  }

  static unmaskField(value) {
    if (value === null || value === undefined || value === '') {
      return undefined
    }
    var unsmaked = value.split('(').join('')
    unsmaked = unsmaked.split(')').join('')
    unsmaked = unsmaked.split(' ').join('')
    unsmaked = unsmaked.split('-').join('')
    unsmaked = unsmaked.split('/').join('')
    unsmaked = unsmaked.split('.').join('')
    return unsmaked
  }
  static mapContratados(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({
        value: value.id,
        label: value.nome_razao_social,
        prepostos: Util.mapItens(value.prepostos),
      })
    })
    return mapped
  }
  static mapItens(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({ value: value.id, label: value.nome })
    })
    return mapped
  }
  static mapGestores(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({ value: value.id, label: value.name })
    })
    return mapped
  }
  static sleep(time) {
    return new Promise((resolve) => setTimeout(resolve, time))
  }
  static mapFiscais(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({
        value: value.id,
        label: value.name,
        contratos: value.contratos,
      })
    })
    return mapped
  }
  static mapUnidades(unidades) {
    var mappedUnidades = [{ value: null, label: '' }]
    unidades.forEach((value) => {
      mappedUnidades.push({ value: value.id, label: value.uni_orc })
    })
    return mappedUnidades
  }
  static mapStates(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({
        value: value.id,
        label: value.name,
        cidades: Util.mapCidades(value.city),
      })
    })
    return mapped
  }
  static mapCidades(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({ value: value.id, label: value.name })
    })
    return mapped
  }
  static mapRoles(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({ value: value.id, label: value.display_name })
    })
    return mapped
  }
  static mapMedidas(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({ value: value.id, label: value.simbolo })
    })
    return mapped
  }
  static mapItensDeContrato(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({
        value: value.id,
        label: value.descricao,
        valor: value.valor_unitario,
        valorTotal:
          parseFloat(value.valor_unitario) *
          parseFloat(value.quantidade_inicial),
      })
    })
    return mapped
  }
  static mapContratos(itens) {
    var mapped = [{ value: null, label: '' }]
    itens.forEach((value) => {
      mapped.push({
        value: value.id,
        label: value.num_contrato + ' - ' + value.objeto,
      })
    })
    return mapped
  }
  static mapTiposDeRelatorios(tipos) {
    var mapped = [{ value: null, label: '' }]
    tipos.forEach((value, key) => {
      mapped.push({ value: key, label: value })
    })
    return mapped
  }
}



// WEBPACK FOOTER //
// ./src/Util.js